<!-- Answer page: total score, LLM analysis, call-to-action, contact form (optional). Contact not sent to LLM. -->
<main class="survey-results survey-container" role="main" aria-label="Survey results">
  @if (!evaluating) {
    <header class="survey-results__header">
      <div class="survey-results__score-block" aria-live="polite">
        <p class="survey-results__score-label">You Scored</p>
        <p
          class="survey-results__score-value"
          [class.survey-results__score-value--red]="scoreBand === 'red'"
          [class.survey-results__score-value--yellow]="scoreBand === 'yellow'"
          [class.survey-results__score-value--light-green]="scoreBand === 'light-green'"
          [class.survey-results__score-value--dark-green]="scoreBand === 'dark-green'"
        >
          {{ displayScore }}%
        </p>
        @if (scoreMessage) {
          <p
            class="survey-results__score-message"
            [class.survey-results__score-message--red]="scoreBand === 'red'"
            [class.survey-results__score-message--yellow]="scoreBand === 'yellow'"
            [class.survey-results__score-message--light-green]="scoreBand === 'light-green'"
            [class.survey-results__score-message--dark-green]="scoreBand === 'dark-green'"
          >
            {{ scoreMessage }}
          </p>
        }
      </div>
    </header>
  }

  <section class="survey-results__analysis" aria-labelledby="analysis-heading">
    <h2 id="analysis-heading" class="survey-results__section-title">Analysis</h2>
    <div class="survey-results__analysis-body">
      @if (evaluating) {
        <p class="survey-results__evaluating" aria-busy="true">Evaluating your responses…</p>
        <p class="survey-results__analysis-body">This evaluation can take 30-45 seconds. Please wait...</p>
      } @else if (result?.analysis) {
        <p>{{ result.analysis }} We can help you.</p>
      } @else {
        <p>Your personalized analysis will appear here.</p>
      }
    </div>
  </section>

  @if (hasCallToAction) {
    <section class="survey-results__cta" aria-labelledby="cta-heading">
      <h2 id="cta-heading" class="survey-results__section-title">Next steps</h2>
      <p class="survey-results__cta-text">{{ result?.callToActionDisplayText }}</p>
    </section>
  }

  <!-- Contact form: only on results page after we have the result; not shown while evaluating -->
  @if (collectContactInfo && !evaluating) {
    <section class="survey-results__contact" aria-labelledby="contact-heading">
      <h2 id="contact-heading" class="survey-results__contact-title">
        Connect with our Team now for a FREE consultation
      </h2>
      <p class="survey-form__hint">
        Interested in learning more? Share your email address or phone number, and a member of our team will reach out to
        discuss your results and answer any questions. Your contact information is collected only after you submit your
        survey and is kept separate from the assessment process.
      </p>
      @if (contactSaved) {
        <p role="status" class="survey-form__hint"><strong>Thank you. Your contact information has been noted. A team member will reach out shortly.</strong></p>
      } @else {
        <form
          class="survey-form survey-results__contact-form"
          role="form"
          aria-labelledby="contact-heading"
          id="survey-contact-form"
          (ngSubmit)="saveContact()"
        >
          @if (contactError) {
            <p class="survey-form__error" role="alert">{{ contactError }}</p>
          }
          <div class="survey-form__group">
            <label class="survey-form__label" for="contact-name">Name</label>
            <input
              #contactNameInput
              class="survey-form__input"
              type="text"
              id="contact-name"
              name="name"
              [maxlength]="limits.name"
              autocomplete="name"
              [(ngModel)]="contact.name"
            />
          </div>
          <div class="survey-form__group">
            <label class="survey-form__label" for="contact-email">Email</label>
            <input
              class="survey-form__input"
              type="email"
              id="contact-email"
              name="email"
              [maxlength]="limits.email"
              autocomplete="email"
              [(ngModel)]="contact.email"
            />
          </div>
          <div class="survey-form__group">
            <label class="survey-form__label" for="contact-phone">Phone number</label>
            <input
              class="survey-form__input"
              type="tel"
              id="contact-phone"
              name="phoneNumber"
              [maxlength]="limits.phoneNumber"
              autocomplete="tel"
              [(ngModel)]="contact.phoneNumber"
            />
          </div>
          <div class="survey-form__group">
            <label class="survey-form__label" for="contact-business">Business name</label>
            <input
              class="survey-form__input"
              type="text"
              id="contact-business"
              name="businessName"
              [maxlength]="limits.businessName"
              autocomplete="organization"
              [(ngModel)]="contact.businessName"
            />
          </div>
          <div class="survey-form__actions">
            <button type="submit" class="btn btn-primary" [disabled]="!contactValid() || contactSaving" [attr.aria-busy]="contactSaving">
              {{ contactSaving ? 'Saving...' : 'Request Contact' }}
            </button>
          </div>
        </form>
      }
    </section>
  }
</main>
